import React from 'react';
import { Clock, Server, Globe } from 'lucide-react';

interface QzTrayTestDetailsCardProps {
  testedHost: string;
  testedPort: number | string;
  responseTimeMs: number;
  testedAt: string;
}

/**
 * 📋 QzTrayTestDetailsCard
 * Muestra la información técnica del resultado de conexión a QZ Tray.
 * Adaptado para modo claro y oscuro, con diseño consistente al modal principal.
 */
const QzTrayTestDetailsCard: React.FC<QzTrayTestDetailsCardProps> = ({
  testedHost,
  testedPort,
  responseTimeMs,
  testedAt,
}) => {
  return (
    <div className="rounded-xl border border-stroke dark:border-strokedark bg-gray-2 dark:bg-[#1E293B] p-5 shadow-sm transition-colors duration-200">
      <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3 uppercase tracking-wide">
        Detalles Técnicos
      </h4>

      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        <InfoRow icon={<Server size={16} />} label="Host" value={testedHost} />
        <InfoRow icon={<Globe size={16} />} label="Puerto" value={testedPort} />
        <InfoRow
          icon={<Clock size={16} />}
          label="Tiempo de respuesta"
          value={`${responseTimeMs} ms`}
        />
        <InfoRow label="Fecha de prueba" value={testedAt} />
      </div>
    </div>
  );
};

export default QzTrayTestDetailsCard;

// 🔹 Subcomponente interno
const InfoRow = ({
  icon,
  label,
  value,
}: {
  icon?: React.ReactNode;
  label: string;
  value?: string | number | null;
}) => (
  <div className="flex items-center justify-between py-2">
    <span className="flex items-center gap-2 text-gray-700 dark:text-gray-300 text-sm">
      {icon && <span className="text-gray-500 dark:text-gray-400">{icon}</span>}
      {label}
    </span>
    <span className="font-medium text-gray-900 dark:text-gray-100 text-sm">{value || '—'}</span>
  </div>
);
